import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "EnumValueListContainer wbg wd100"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_EmdEnumValueListView = _resolveComponent("EmdEnumValueListView");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_EmdEnumValueListView, {
    onFetch: $options.onFetchData,
    title: $data.title,
    "init-query": $data.initQuery,
    type: $data.type
  }, {
    extra: _withCtx(data => [_createElementVNode("span", null, _toDisplayString(data.data.extra), 1)]),
    _: 1
  }, 8, ["onFetch", "title", "init-query", "type"])]);
}